import { FC, useState } from 'react';
import { BackIcon } from 'assets/icons';
import { CustomButton, CustomTextArea } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { notesMaxCount } from 'containers/settings/constants';

interface EditEstimateNotePanelProps {
  note: string;
  onBackClick: () => void;
  onSave: (note: string) => void;
}

const EditEstimateNotePanel: FC<EditEstimateNotePanelProps> = ({ note, onBackClick, onSave }) => {
  const [estimateNote, setEstimateNote] = useState(note);

  const onSaveClick = () => {
    onSave(estimateNote.trim());
  };

  return (
    <div className="h-full w-96">
      <div className="mb-1 flex items-center border-b border-secondaryBtn py-4">
        <BackIcon className="mx-4 cursor-pointer" id="estimate-details-panel-back-arrow" onClick={onBackClick} />
        <div className="text-17px font-semibold text-headingGray">Note</div>
      </div>
      <div className="py-6 px-4">
        <CustomTextArea
          id="edit-estimate-note"
          name="edit-estimate-note"
          placeholder="Enter notes"
          className="h-[140px] max-h-[140px] rounded-md border border-borderGray bg-transparent font-semibold 
                    text-primaryText focus:outline-none"
          value={estimateNote}
          onChange={setEstimateNote}
          maxLength={notesMaxCount}
          showRemainingChar={true}
        />
      </div>
      <div className="flex w-full flex-col gap-y-4 p-4 pt-0">
        <CustomButton
          id="edit-estimate-note-save-button"
          className="w-full"
          onClick={onSaveClick}
          type={ButtonType.PRIMARY}
          disabled={note.trim() === estimateNote.trim()}>
          Save
        </CustomButton>
        <CustomButton
          id="edit-estimate-note-cancel-button"
          className="w-full"
          onClick={onBackClick}
          type={ButtonType.SECONDARY}>
          Cancel
        </CustomButton>
      </div>
    </div>
  );
};

export default EditEstimateNotePanel;
